import { useTranslation } from 'react-i18next';
import type { AuthMe } from '~shared/schemas';

/** Почему вошедший не участвует в акции (landing, «Уведомление неучаствующему участнику»). */
export type NotEligibleReason = 'COUNTRY_NOT_IN_PROMO' | 'ANONYMOUS' | 'NOT_FOUND';

/**
 * Причина — из профиля `/api/auth/me`, он пересчитывается при каждом открытии лендинга.
 * Озеро недоступно (`profileIssue: 'UNAVAILABLE'`) — не причина: кнопку оставляем, решит сервер.
 */
export function notEligibleReason(participant: AuthMe): NotEligibleReason | null {
  if (participant.profileIssue === 'NOT_FOUND') return 'NOT_FOUND';
  const status = participant.profile?.status;
  return status === 'COUNTRY_NOT_IN_PROMO' || status === 'ANONYMOUS' ? status : null;
}

const KEYS = {
  COUNTRY_NOT_IN_PROMO: 'country',
  ANONYMOUS: 'anonymous',
  NOT_FOUND: 'notFound',
} as const;

/** Уведомление на первом экране вместо кнопки «Участвую в акции». */
export function NotEligibleNotice({ reason }: { reason: NotEligibleReason }) {
  const { t } = useTranslation('landing');
  const key = KEYS[reason];
  return (
    <div className="noteligible" role="status">
      <b className="ne-title">{t(`notEligible.${key}.title`)}</b>
      <span className="ne-text">{t(`notEligible.${key}.text`)}</span>
    </div>
  );
}
